export enum MatchExceptionToleranceValueType {
  FixedAmount = 1,
  /** Percentage */
  Percentage = 2,
}
